<template>
  <v-card style="border-radius: 0; box-shadow: none !important">
    <v-card-title
      class="primary textOverSecondary--text py-4 px-10 text-subtitle-1"
    >
      <v-row>
        <v-col cols="8">
          <div style="white-space: nowrap">{{ eventName }}</div>
        </v-col>
        <v-col cols="4" class="font-weight-bold text-right">
          <div
            style="cursor: pointer"
            @click="$router.push({ name: routeNames.QR })"
          >
            {{ $t("main.see_qr") }}
            <v-icon class="mr-2 textOverSecondary--text">qr_code</v-icon>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="secondary py-4">
      <v-row class="text-left primary--text">
        <v-col cols="6" class="pl-12">
          <h2>{{ $t("main.balance") }}</h2>
          <p>
            <amount class="mb-3" showDecimal :balance="balance" />
          </p>
        </v-col>
        <v-col
          cols="6"
          class="text-center"
          @click="$router.push({ name: routeNames.TOKENS })"
          style="cursor: pointer"
        >
          <h2>
            {{ $t("main.token") }}
            <icon
              :name="'star'"
              :color="this.$vuetify.theme.themes.light.primary"
              width="20"
            ></icon>
          </h2>
          <div
            class="mt-3 text-h4 font-weight-bold primary--text rounded-pill mx-10"
            style="
              border: 2px solid var(--primary-color);
              background-color: #fff;
            "
          >
            {{ tokens | getTotalTokens }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Amount from "@/components/FormattedBalance";
import { mapState } from "vuex";

export default {
  props: {
    balance: Number,
    tokens: Array,
    routeNames: Object,
  },
  components: {
    Amount,
  },
  filters: {
    getTotalTokens(tokens) {
      return tokens.reduce((total, token) => {
        return total + token.amount;
      }, 0);
    },
  },
  computed: {
    ...mapState({
      eventName: (state) => state.customization.customization.name,
    }),
  },
};
</script>
